import { AdminPanelSettings, ExitToApp, MeetingRoom, VideoCameraFrontRounded } from '@mui/icons-material'
import { MenuItem } from '@mui/material'
import Menu from '@mui/material/Menu'
import { AgoraVideoPlayer } from 'agora-rtc-react'
import { MVPButton } from 'mvppoker-portal-common/components'
import React, { useEffect, useMemo } from 'react'
import { useAgoraLocalTracks } from '../../logic/video/AgoraLocal'
import Marquee from '../Lobby/Marquee/Marquee'
import './PrepareGameVideoPage.scss'

export interface PrepareGameVideoPageViewProps
{
	hasPermissions: boolean
	isCameraSet: boolean

	clickCheckPermissions: () => void
	clickSelectCamera: (name: string) => void
	clickContinue: () => void
	clickBack: () => void
}

export const PrepareGameVideoPageView : React.FC<PrepareGameVideoPageViewProps> = ({ hasPermissions, isCameraSet, clickCheckPermissions, clickSelectCamera, clickContinue, clickBack }) =>
{
	const [menuAnchor, setMenuAnchor] = React.useState<null | HTMLElement>(null)
	const { availableCameras, setSelectedCamera, loadDevices, ready, tracks } = useAgoraLocalTracks()

	const clickConfigureCamera = (e: React.MouseEvent<HTMLElement>) => {
		setMenuAnchor(e.target as unknown as HTMLElement)
	}

	const clickCloseConfigureCamera = () => {
		setMenuAnchor(null)
	}

	const clickSelectDevice = (device: MediaDeviceInfo) => {
		clickSelectCamera(device.deviceId)
		setSelectedCamera(device)
		clickCloseConfigureCamera()
	}

	useEffect(() => {
		if (hasPermissions && availableCameras.length === 0){
			loadDevices()
		}
	}, [hasPermissions, availableCameras])

	// Preselect any camera
	useEffect(() => {
		const video = tracks?.[1]
		if (ready && video && availableCameras) {
			if (availableCameras.length > 0){
				const camera = availableCameras[0]
				clickSelectCamera(camera.deviceId)
				setSelectedCamera(camera)
			}
		}
	}, [availableCameras, ready, tracks])

	const deviceList = useMemo(() => {
		return availableCameras.map((it) => (
			<MenuItem key={it.deviceId} onClick={() => clickSelectDevice(it)}>
				{it.label}
			</MenuItem>
		))
	}, [availableCameras])

	return (
		<div id='prepare-game-video-page'>

			<MVPButton id='button-leave' variant='contained' onClick={clickBack}>
				<ExitToApp />
				&nbsp;Leave
			</MVPButton>

			<div id='main'>

				<div id='top'>
					<h1>Your Camera</h1>
					{!hasPermissions && <MVPButton id='button-permissions' onClick={clickCheckPermissions}>
						<AdminPanelSettings />
						&nbsp;Check Permissions
					</MVPButton>}
					{hasPermissions && <MVPButton id='button-configure' onClick={clickConfigureCamera}>
						<VideoCameraFrontRounded />
						&nbsp;Configure
					</MVPButton>}
				</div>

				<div id='video'>
					{ready && tracks && <AgoraVideoPlayer id='user-test-video' videoTrack={tracks[1]} />}
					<Menu
						anchorEl={menuAnchor}
						anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
						keepMounted
						open={Boolean(menuAnchor)}
						onClose={clickCloseConfigureCamera}
					>
						{deviceList}
					</Menu>
				</div>
				
				<MVPButton id='button-join' variant='contained' onClick={clickContinue} disabled={!isCameraSet || !hasPermissions}>
					<MeetingRoom />
					&nbsp;Join
				</MVPButton>
			</div>
			<Marquee />
		</div>
	)
}